'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MenuSubmenuTrigger: ()=>Menu_components_MenuSubmenuTrigger,
    MenuItem: ()=>Menu_components_MenuItem,
    MenuCheckboxItem: ()=>Menu_components_MenuCheckboxItem,
    MenuGroupLabel: ()=>Menu_components_MenuGroupLabel,
    MenuPositioner: ()=>Menu_components_MenuPositioner,
    MenuSubmenuRoot: ()=>MenuSubmenuRoot,
    MenuGroup: ()=>Menu_components_MenuGroup,
    MenuPopup: ()=>Menu_components_MenuPopup,
    MenuPortal: ()=>MenuPortal,
    MenuRadioItem: ()=>Menu_components_MenuRadioItem,
    MenuArrow: ()=>Menu_components_MenuArrow,
    MenuRadioGroup: ()=>Menu_components_MenuRadioGroup,
    MenuRoot: ()=>MenuRoot,
    MenuSeparator: ()=>Menu_components_MenuSeparator,
    MenuTrigger: ()=>Menu_components_MenuTrigger
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const menu_namespaceObject = require("@base-ui-components/react/menu");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Menu_variants_cjs_namespaceObject = require("./Menu.variants.cjs");
const MenuRoot = menu_namespaceObject.Menu.Root;
const Menu_components_MenuTrigger = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, iconLeft, iconRight, size, open, disabled, fullWidth, ...props }, ref) {
    const { trigger, triggerIcon } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)({
        size,
        open,
        disabled,
        fullWidth
    });
    const iconSizes = {
        sm: '16',
        md: '20',
        lg: '24'
    };
    const iconSize = iconSizes[size ?? 'md'];
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(menu_namespaceObject.Menu.Trigger, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(trigger(), className),
        ...props,
        children: [
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconLeft,
                className: (0, index_cjs_namespaceObject.cn)(triggerIcon()),
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: "flex-1",
                children: children
            }),
            iconRight && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconRight,
                className: (0, index_cjs_namespaceObject.cn)(triggerIcon()),
                size: iconSize
            })
        ]
    });
});
const MenuPortal = menu_namespaceObject.Menu.Portal;
const Menu_components_MenuPositioner = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ className, ...props }, ref) {
    const { positioner } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.Positioner, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(positioner(), className),
        ...props
    });
});
const Menu_components_MenuPopup = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, ...props }, ref) {
    const { popup } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.Popup, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(popup(), className),
        ...props,
        children: children
    });
});
const Menu_components_MenuArrow = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ className, ...props }, ref) {
    const { arrow } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.Arrow, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(arrow(), className),
        ...props,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
            width: "20",
            height: "10",
            viewBox: "0 0 20 10",
            fill: "none",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                d: "M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z",
                className: "fill-current"
            })
        })
    });
});
const Menu_components_MenuItem = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, iconLeft, iconRight, suffix, disabled, ...props }, ref) {
    const { item, itemIcon, itemText, itemSuffix } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)({
        itemDisabled: disabled
    });
    const iconSize = '20';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(menu_namespaceObject.Menu.Item, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(item(), className),
        ...props,
        children: [
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconLeft,
                className: (0, index_cjs_namespaceObject.cn)(itemIcon()),
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: (0, index_cjs_namespaceObject.cn)(itemText()),
                children: children
            }),
            suffix && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: (0, index_cjs_namespaceObject.cn)(itemSuffix()),
                children: suffix
            }),
            iconRight && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconRight,
                className: (0, index_cjs_namespaceObject.cn)(itemIcon()),
                size: iconSize
            })
        ]
    });
});
const Menu_components_MenuSeparator = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ className, ...props }, ref) {
    const { separator } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.Separator, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(separator(), className),
        ...props
    });
});
const Menu_components_MenuGroup = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, ...props }, ref) {
    const { group } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.Group, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(group(), className),
        ...props,
        children: children
    });
});
const Menu_components_MenuGroupLabel = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, ...props }, ref) {
    const { groupLabel } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.GroupLabel, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(groupLabel(), className),
        ...props,
        children: children
    });
});
const Menu_components_MenuCheckboxItem = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, iconLeft, disabled, ...props }, ref) {
    const { checkboxItem, itemIcon, itemText } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)({
        itemDisabled: disabled
    });
    const iconSize = '20';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(menu_namespaceObject.Menu.CheckboxItem, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(checkboxItem(), className),
        ...props,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.CheckboxItemIndicator, {
                className: "flex h-[20px] w-[20px] items-center justify-center",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                    iconName: "check",
                    size: "16"
                })
            }),
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconLeft,
                className: (0, index_cjs_namespaceObject.cn)(itemIcon()),
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: (0, index_cjs_namespaceObject.cn)(itemText()),
                children: children
            })
        ]
    });
});
const Menu_components_MenuRadioGroup = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, ...props }, ref) {
    const { radioGroup } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.RadioGroup, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(radioGroup(), className),
        ...props,
        children: children
    });
});
const Menu_components_MenuRadioItem = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, iconLeft, disabled, ...props }, ref) {
    const { radioItem, itemIcon, itemText } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)({
        itemDisabled: disabled
    });
    const iconSize = '20';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(menu_namespaceObject.Menu.RadioItem, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(radioItem(), className),
        ...props,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(menu_namespaceObject.Menu.RadioItemIndicator, {
                className: "flex h-[20px] w-[20px] items-center justify-center",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                    iconName: "radio_button_checked",
                    size: "16"
                })
            }),
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconLeft,
                className: (0, index_cjs_namespaceObject.cn)(itemIcon()),
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: (0, index_cjs_namespaceObject.cn)(itemText()),
                children: children
            })
        ]
    });
});
const MenuSubmenuRoot = menu_namespaceObject.Menu.SubmenuRoot;
const Menu_components_MenuSubmenuTrigger = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, iconLeft, disabled, ...props }, ref) {
    const { submenuTrigger, itemIcon, itemText, submenuArrow } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)({
        itemDisabled: disabled
    });
    const iconSize = '20';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(menu_namespaceObject.Menu.SubmenuTrigger, {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(submenuTrigger(), className),
        ...props,
        children: [
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconLeft,
                className: (0, index_cjs_namespaceObject.cn)(itemIcon()),
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: (0, index_cjs_namespaceObject.cn)(itemText()),
                children: children
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: "chevron_right",
                className: (0, index_cjs_namespaceObject.cn)(submenuArrow()),
                size: "16"
            })
        ]
    });
});
exports.MenuArrow = __webpack_exports__.MenuArrow;
exports.MenuCheckboxItem = __webpack_exports__.MenuCheckboxItem;
exports.MenuGroup = __webpack_exports__.MenuGroup;
exports.MenuGroupLabel = __webpack_exports__.MenuGroupLabel;
exports.MenuItem = __webpack_exports__.MenuItem;
exports.MenuPopup = __webpack_exports__.MenuPopup;
exports.MenuPortal = __webpack_exports__.MenuPortal;
exports.MenuPositioner = __webpack_exports__.MenuPositioner;
exports.MenuRadioGroup = __webpack_exports__.MenuRadioGroup;
exports.MenuRadioItem = __webpack_exports__.MenuRadioItem;
exports.MenuRoot = __webpack_exports__.MenuRoot;
exports.MenuSeparator = __webpack_exports__.MenuSeparator;
exports.MenuSubmenuRoot = __webpack_exports__.MenuSubmenuRoot;
exports.MenuSubmenuTrigger = __webpack_exports__.MenuSubmenuTrigger;
exports.MenuTrigger = __webpack_exports__.MenuTrigger;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MenuArrow",
    "MenuCheckboxItem",
    "MenuGroup",
    "MenuGroupLabel",
    "MenuItem",
    "MenuPopup",
    "MenuPortal",
    "MenuPositioner",
    "MenuRadioGroup",
    "MenuRadioItem",
    "MenuRoot",
    "MenuSeparator",
    "MenuSubmenuRoot",
    "MenuSubmenuTrigger",
    "MenuTrigger"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
